import React, { Component } from 'react';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

/* React Router */
import { withRouter } from 'react-router-dom';

/* Redux */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../../redux/ducks';
import { actions as notificationActions } from '../../../redux/ducks/notification';

/* Routes */
import { domainIsTenant as dit, S, domain } from '../../../routes/routes';

/* Object Json */
import { safeGetWithType, stringify, safeGet } from 'iotera-base/json';

import { SubViewHeader } from '../../../lib/components/subHeader';
import { IoteraForm } from '../../../lib/components/form';
import { AreaInput } from '../../../lib/components/textInput';
import {
  setCallbackGlobal,
  unsetCallbackGlobal,
} from '../../../lib/components/callbackGlobal';
import { isEmpty } from 'iotera-base/object';

const INIT_INFO = 'INIT_INFO';
const EDIT = 'EDIT';
const WKEY = 'DEVICE_INFO';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

const schema = {
  type: 'object',
  required: ['emma_plugin_name', 'emma_plugin_details'],
  properties: {
    emma_plugin_name: {
      type: 'string',
      title: 'Plugin Name',
      maxLength: 256,
    },
    emma_plugin_details: {
      type: 'string',
      title: 'Plugin Details',
      default: '{}',
    },
  },
};

const uiSchema = {
  emma_plugin_name: {
    'ui:disabled': true,
  },
  emma_plugin_details: {
    'ui:widget': props => {
      return (
        <AreaInput
          id="emma_plugin_details"
          type="text"
          label="Plugin Details"
          textTooltip="Plugin Details"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
          areaHeight={200}
          {...props}
        />
      );
    },
    'ui:options': {
      label: false,
    },
  },
};

class EmmaInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
    this.isTenant = dit(props);
    this.domain = domain(props);

    this.id = safeGet(props, ['match', 'params', 'id']);
    this.isTenant = dit(props);
    this.domain = domain(props);
  }

  componentDidMount() {
    const self = this;
    const props = self.props;

    // Callback global
    setCallbackGlobal(props);

    props.wInitRequestCall({
      wparam: {
        ...self.isTenant,
        path: '/service/web/device/emma/get/id/' + self.id,
      },
      wreducer: {
        rparse: function (id, result, rpayload) {
          const item = {
            emma_plugin_name: safeGet(rpayload, [
              'emma_plugin_definition',
              'name',
            ]) + ' - ' + safeGet(rpayload, 'emma_plugin_application_id'),
            emma_plugin_details: stringify(
              safeGet(rpayload, 'emma_plugin_details'),
            ),
          };
          self.setState({ loading: false, formData: { ...item } });
          return item;
        },
      },
    });
  }

  componentWillUnmount() {
    const props = this.props;

    // Callback global
    unsetCallbackGlobal(props);
    props.wUnsetConfig({ key: WKEY });
  }

  goTo(link) {
    this.props.history.push(link);
  }

  render() {
    const self = this;
    const props = this.props;
    const state = this.state;
    const { loading, formData } = state;
    let shouldRenderForm = true;

    let shownFormData = formData;
    const item = safeGetWithType(props, 'item', {});
    shownFormData = item;
    shouldRenderForm = !isEmpty(shownFormData);

    const spinner = (
      <div className="centeringItem">
        <ReactLoading type="bubbles" color="#000" />
      </div>
    );

    return (
      <Loader
        show={loading}
        message={spinner}
        backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}
      >
        <div className="view">
          <SubViewHeader title="Info Iotera" />
          <div className="io-container mt-12">
            {shouldRenderForm && (
              <IoteraForm
                schema={schema}
                uiSchema={uiSchema}
                formData={shownFormData}
              >
                <div className="button-right" style={{ marginTop: 10 }}>
                  <button
                    className="button-iotera-white"
                    type="button"
                    style={{ minWidth: '0%' }}
                    onClick={e =>
                      self.goTo(
                        '..' + S + '..' + S + '..' + S + '_device_list_',
                      )
                    }
                  >
                    Kembali
                  </button>
                </div>
              </IoteraForm>
            )}
          </div>
        </div>
      </Loader>
    );
  }
}

const mapStateToProps = function (state, ownProps) {
  return {
    item: wSelector.getSoleInitMappedRPayload(state),
  };
};

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(EmmaInfo));
